export enum TargetAudienceGenderEnum
    {
        All = 'All',
        Male = 'Male',
        Female = 'Female'
    }
